<template>
  <div id="admin-header">
    <!-- Sidenav -->
    <nav class="navbar navbar-vertical fixed-left border-right navbar-expand-md bg-white navbar-light"
      id="sidenav-main">
      <div class="container-fluid">
        <!-- Toggler -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidenav-collapse-main"
          aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Brand -->
        <router-link :to="{ name: 'Home' }" class="mx-auto brand">
          <img src="@/assets/img/brand/logo-round-sm.png" class="navbar-brand-img" alt="...">
        </router-link>

        <!-- User (mobile) -->
        <ul class="nav align-items-center d-md-none">
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="@/assets/img/theme/user.png">
                </span>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">Welcome!</h6>
              </div>
              <router-link :to="{ name: 'sitePreferences' }" class="dropdown-item">
                <i class="fas fa-map-marker-alt"></i>
                <span>My Sites</span>
              </router-link>
              <router-link :to="{ name: 'changePassword' }" class="dropdown-item">
                <i class="ni ni-settings-gear-65"></i>
                <span>Change Password</span>
              </router-link>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item" @click.prevent="logout">
                <i class="ni ni-user-run"></i>
                <span>Logout</span>
              </a>
            </div>
          </li>
        </ul>

        <!-- Collapse -->
        <div class="collapse navbar-collapse" id="sidenav-collapse-main">
          <!-- Collapse header -->
          <div class="navbar-collapse-header d-md-none">
            <div class="row">
              <div class="col-6 collapse-brand">
                <a href="@/index.html">
                  <img src="@/assets/img/brand/logo-round-sm.png" class="navbar-brand-img" alt="...">
                </a>
              </div>
              <div class="col-6 collapse-close">
                <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#sidenav-collapse-main"
                  aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle sidenav">
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>

          <!-- Navigation -->
          <ul class="navbar-nav">
            <li class="nav-item">
              <span v-b-toggle.sessions class="nav-link">
                <i class="fas fa-project-diagram"></i> Sessions <span class="float-right"> <i
                    class="fa-plus-circle fas"></i></span>
              </span>
              <b-collapse id="sessions">
                <ul class="pl-0">
                  <li class="nav-item">
                    <router-link :to="{ name: 'openSession' }" class="nav-link">
                      <i class="fas fa-door-open mr-2"></i> Open Sessions
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'completedSession' }" class="nav-link">
                      <i class="fas fa-check-circle mr-2"></i> Closed Sessions
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'adhocSession' }" class="nav-link">
                      <i class="fas fa-bolt mr-2"></i> Adhoc Sessions
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link :to="{ name: 'billSearch' }" class="nav-link">
                      <i class="fas fa-search mr-2"></i> Bill Search
                    </router-link>
                  </li>
                </ul>
              </b-collapse>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'mailing' }" class="nav-link">
                <i class="fas fa-envelope-open-text"></i> All Mailings
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'manageAddressBook' }" class="nav-link">
                <i class="fas fa-address-book"></i> Manage Address Book
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'manageMobileUsers' }" class="nav-link">
                <i class="fas fa-mobile-alt"></i> Manage Mobile Users
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'meterResetManager' }" class="nav-link">
                <i class="fas fa-tachometer-alt"></i> Manage Meters
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'sitePreferences' }" class="nav-link">
                <i class="fas fa-map-marker-alt"></i> My Sites
              </router-link>
            </li>
          </ul>

          <div class="admin-sidebar-footer">
            <a href="#" class="sidebar-logout-link" @click.prevent="logout">
              <i class="ni ni-user-run mr-2"></i> Sign Out
            </a>
            <div class="admin-sidebar-version">Version {{ versionLabel }}</div>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main content -->
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { appVersion } from '@/config'
import ApiServices from '@/services/api'

export default {
  computed: {
    versionLabel() {
      return `v${appVersion}`
    }
  },
  methods: {
    logout() {
      localStorage.clear()
      this.$router.replace({ name: 'adminLogin' })
    }
  },
  mounted() {
    // Auto-redirect to site preferences if no sites have been selected yet.
    // Skip the check if already on that page to avoid a redirect loop.
    if (this.$route.name === 'sitePreferences') return

    ApiServices.getUserSitePreferences()
      .then(response => {
        const sites = (response && response.data) ? response.data : []
        if (sites.length === 0) {
          this.$router.replace({
            name: 'sitePreferences',
            query: { redirect: this.$route.fullPath }
          })
        }
      })
      .catch(() => {
        // Silently ignore — if the check fails, don't block the user
      })
  }
}
</script>

<style>
#admin-header #sidenav-collapse-main {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 120px);
}

#admin-header .admin-sidebar-footer {
  margin-top: auto;
  padding: 1rem 0 0.25rem;
  border-top: 1px solid #e9ecef;
}

#admin-header .sidebar-logout-link {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.82rem;
  font-weight: 600;
  color: #525f7f;
  text-decoration: none;
  padding:  1rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  background: #eef2ff;
  letter-spacing: 0.03em;
  transition: background 0.15s ease, color 0.15s ease;
}

#admin-header .sidebar-logout-link:hover {
  background: #fde8ea;
  color: #e63946;
}

#admin-header .admin-sidebar-version {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-top: 0.25rem;
}

/* Hover state for all nav links */
#admin-header .navbar-nav .nav-link:hover {
  background: #eef6fd;
  color: #2c7be5;
}

/* Active state — exact match (top-level direct links) */
#admin-header a.nav-link.router-link-exact-active {
  background: #d0eafb;
  color: #1a6fc4;
  border-left: 3px solid #2c7be5;
  font-weight: 600;
}

/* Active state — partial match (sub-items inside a collapse) */
#admin-header .b-collapse .nav-link.router-link-active {
  background: #d0eafb;
  color: #1a6fc4;
  border-left: 3px solid #2c7be5;
  font-weight: 600;
}

/* Indent compensation when border-left is applied */
#admin-header a.nav-link.router-link-exact-active,
#admin-header .b-collapse .nav-link.router-link-active {
  padding-left: calc(1rem - 3px);
}

/* Ensure the top navbar dropdown renders above all page content */
#navbar-main {
  position: relative;
  z-index: 1040;
}

/* Pull navbar back into normal document flow so content sits directly below it.
   The Argon default makes .navbar-top position:absolute which requires pages
   to use pt-md-8 (8rem) as a clearance hack — that's the source of the gap. */
.main-content .navbar-top {
  position: relative !important;
  top: auto !important;
}

/* With the navbar in flow, pt-md-8 becomes a huge redundant gap — collapse it */
.main-content .container-fluid.pt-md-8,
.main-content .container-fluid.pt-5 {
  padding-top: 1.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/admin.vue